/**
 * Ambient request context shared by every API call: the merchant identity
 * (`x-merchant`), the Fastrr dashboard session token (`x-auth-token`), and the
 * host-supplied session info (`x-session-info`). Updated by the session store;
 * read by the API client. Kept here to avoid a circular dependency between the
 * store and the api layer.
 */

let activeMerchantDomain = '';
let activeAuthToken: string | null = null;
let activeSessionInfo: string | null = null;

export function setActiveMerchantDomain(domain: string): void {
  activeMerchantDomain = domain.trim();
}

export function getActiveMerchantDomain(): string {
  return activeMerchantDomain;
}

export function setActiveAuthToken(token: string | null): void {
  activeAuthToken = token;
}

export function getActiveAuthToken(): string | null {
  return activeAuthToken;
}

export function setActiveSessionInfo(sessionInfo: string | null): void {
  activeSessionInfo = sessionInfo;
}

export function getActiveSessionInfo(): string | null {
  return activeSessionInfo;
}

/**
 * Callback the session store registers so the API client can trigger a logout
 * when a call comes back unauthorized / missing session info. Kept here (not in
 * the store) to avoid a circular dependency between the store and the client.
 */
let authExpiredHandler: (() => void) | null = null;

export function setAuthExpiredHandler(handler: (() => void) | null): void {
  authExpiredHandler = handler;
}

export function notifyAuthExpired(): void {
  authExpiredHandler?.();
}
